import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGraylogComponent } from './simple-icons-graylog.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGraylogComponent ],
    exports:      [ SimpleIconsGraylogComponent ],
    bootstrap:    []
})
export class SimpleIconsGraylogModule {}
